var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnRinnova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.989,
    height: 18,
    viewBox: "0 0 17.989 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:props.fill;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Icon_material-refresh",
    "data-name": "Icon material-refresh",
    d: "M21.36,8.644A9,9,0,1,0,23.7,17.25H21.36A6.747,6.747,0,1,1,15,8.25a6.654,6.654,0,0,1,4.747,2l-3.623,3.622H24V6Z",
    transform: "translate(-6.015 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRinnova);
export default __webpack_public_path__ + "static/media/icn_rinnova.5216adad.svg";
export { ForwardRef as ReactComponent };